





























































































































































































































import Vue from 'vue';
import { Component, Watch } from 'vue-property-decorator';
import ListViewItem from 'list-view/src/listviewitem';
import NewsModel from '@views/a-model/news-model';
import DefaultModel from '@views/a-model/default-model';
import EnumNewsType from '../../dataSource/api/RunPay/DataModels/Enums/EnumNewsType';
import ControlValidatorGroupComponent from '../components/control-validator-group.vue';
import iMobileDeviceUser from '../a-model/interfaces/iMobileDeviceUser';
import { EnumRoleType } from '../a-model/enum/EnumRoleType';
import iKpi from '../a-model/interfaces/iKpi';
import iKpiUser from '../a-model/interfaces/iKpiUser';
import MarkerTemplate from '../components/ui-maps/markerTemplate';
import Position from '../components/ui-maps/position';
import Route from '../components/ui-maps/route';
import moment = require('moment');
import PosMarkerData from '../a-model/posMarkerData';
import MapItemResponse from '../../dataSource/api/RunPay/Admin/IServices/Models/Map/MapItemResponse';
import EnumPosDeviceType from '../../dataSource/api/RunPay/Admin/IServices/Enums/EnumPosDeviceType';
import TrackStatisticItemResponse from '../../dataSource/api/RunPay/Admin/IServices/Models/Map/TrackStatisticItemResponse';

enum EnumStatus {
  Success = 0,
  TechnicalProblem = 2,
  NoConnection = 1,
  CashCollection = 3,
  Install = 4,
  NegativeAvailableBalance = 5,
}
// declare var google: any;
@Component({
  name: 'gps-tracker',
  components: {},
})
export default class GpsTrackerComponent extends Vue {
  key: string = 'AIzaSyDX7Cc_IGqQsLRE57xfmGPlGBPDrOD-pd0';
  distance: string = '';

  mobileUsers: ListViewItem<DefaultModel>[] = [];

  innerItems: Route[] = [];
  // innerItems:  Route[] = [];
  full = false; // полный вид легенды
  fromDate: Date = new Date();
  fromDateTo: Date = new Date();
  fromDate1: Date = new Date();
  // fromDate:Date= new Date(2019, 10, 29)
  center: Position = new Position(47.0264, 28.8404);
  isLoading = false;
  eventDatesArray: Date[] = [];
  countPoint: number[][] = [[0, 0, 0, 0, 0, 0], [0, 0, 0, 0, 0, 0]];
  imgPath = '/assets/img/maps/';
  showPosMarkers = false;
  innerPostItems: PosMarkerData[] = [];

  //  enventDates = [
  //   { date: new Date("12.1.2019"), text: "Новый год", color: "red" },
  //   { date: new Date("12.12.2019"), text: "Рождество", color: "green" },
  //   {
  //     date: new Date("12.21.2019"),
  //     text: "День смерти В. Ленина",
  //     color: "orange"
  //   },
  //   { date: new Date("12.22.2019"), text: "День рождения", color: "orange" }
  // ];
  onMarkerClick() {}

  created() {
    document.title = this.$route.meta.title;
    this.getMobileUsers('');
  }

  changeAutocomlite(serchTermit: string) {
    this.getMobileUsers(serchTermit);
  }
  onShowPosMarkers(value: boolean) {
    this.showPosMarkers = value;
  }
  onChangeUser() {
    this.getEventDate(this.mobileUsers.filter((item) => item.Selected == true)[0].Value.id);
  }
  onDistance(value: number) {
    // console.log('---', value);
    this.distance = Number(value / 1000).toFixed(2);
  }
  getMobileUsers(search: string): Boolean {
    this.$api.MapService.GetUsersForMapEvent.once((response) => {
      if (!response.IsSuccess) {
        return false;
      }
      this.mobileUsers = [];
      response.Value.forEach((element) => {
        this.mobileUsers.push(new ListViewItem(new DefaultModel(element.UserId, element.UserName.toString()), false, false));
      });
    });
    this.$api.MapService.GetUsersForMap({ Search: search });
    return true;
  }

  getEventDate(id: Number) {
    this.$api.MapService.GetDatesWithTrackInfoEvent.once((response) => {
      if (!response.IsSuccess) {
        return;
      }
      this.eventDatesArray = response.Value;
    });
    // this.eventDatesArray.push({date:new Date("1.6.2019"),text:"",color:"green"})
    // date: new Date("1.6.2019"), text: "Рождество", color: "green"
    if (id == null) {
      this.$api.MapService.GetDatesWithTrackInfo({});
    } else this.$api.MapService.GetDatesWithTrackInfo({ UserId: Number(id) });
  }

  getPoss() {
    this.isLoading = true;
    this.$api.MapService.GetPosMarkersEvent.once((resp) => {
      if (!resp.IsSuccess) {
        this.isLoading = false;
        this.$notification.error(resp.ErrorMessage.toString());
        return;
      }

      this.innerPostItems = [];
      this.innerPostItems = resp.Value.map((el) => ({
        id: el.Id,
        positionPoint: {
          lng: el.Position.Longtitude == null ? 0 : parseFloat(el.Position.Longtitude.toString()),
          lat: el.Position.Lattitude == null ? 0 : parseFloat(el.Position.Lattitude.toString()),

          // lng:el.Position.Longtitude==null?0:parseInt(el.Position.Longtitude.toString()):this.getRandomInt(100),
          // lat:el.Position.Lattitude!=undefined?parseInt(el.Position.Lattitude.toString()):this.getRandomInt(100)
        },
        icon: this.getIconForPos(el), // typesMarker.type2,
        typePoint: this.$options.filters.terminaleTypeName(el.Type),
        statusPoint: this.$options.filters.terminaleStatusName(el.Status),
        draggable: false,
        businessHours: el.BusinessHours ? el.BusinessHours.toString() : '',
        photoUrl: el.PhotoUrl ? el.PhotoUrl.toString() : '',
      }));
      this.isLoading = false;
    });
    var selectedUser = this.mobileUsers.filter((item) => item.Selected == true);
    this.$api.MapService.GetPosMarkers({ UserId: selectedUser[0].Value.id });
  }

  getIconForPos(item: MapItemResponse): string {
    // debugger
    if (item.Status == null) {
      return ''; // временно
    }
    var prefix = item.Type == EnumPosDeviceType.RunPayMini ? 'mini' : 'cash';
    var postfix = this.getPosDeviceType(item.Status);
    if (prefix == 'mini') this.countPoint[1][item.Status] = this.countPoint[1][item.Status] + 1;
    if (prefix == 'cash') this.countPoint[0][item.Status] = this.countPoint[0][item.Status] + 1;
    return `${this.imgPath}${prefix}_${postfix}.svg`;
  }

  getPosDeviceType(id: number): string {
    // debugger
    for (var element in EnumStatus) {
      if (id.toString() == element) {
        return EnumStatus[element];
      }
    }
  }

  getItems() {
    this.$api.MapService.GetUserTrackDataEvent.once((response) => {
      if (!response.IsSuccess) {
        this.$notification.error(response.ErrorMessage.toString());
        return;
      }
      this.innerItems = [];
      // console.log(this.showPosMarkers);
      if (this.showPosMarkers) {
        this.getPoss();
      }
      const pointRoute1 = response.Value.map((item) => ({
        lat: Number(item.Lattitude),
        lng: Number(item.Longtitude),
      }));
      if (pointRoute1.length > 0) {
        this.innerItems.push({ points: pointRoute1 });
      }
      // this.recalcCenter();
    });
    // debugger;
    var selectedUser = this.mobileUsers.filter((item) => item.Selected == true);
    if (selectedUser.length == 0) {
      this.$notification.error('Нет маршрутов в данном диапазоне дат.');
      return;
    }
    this.$api.MapService.GetUserTrackData({
      UserId: selectedUser[0].Value.id,
      DateFrom: moment(this.fromDate)
        .utc(true)
        .toDate(),
      DateTo: moment(this.fromDateTo)
        .utc(true)
        .toDate(),
    });
  }

  // recalcCenter() {
  //   const obj: { lngSum: number; latSum: number; sum: number } = this.innerItems
  //   .reduce((arr: Position[], c: Route) => arr.concat(c.points), [])
  //     .filter(
  //       x => x && x.lat && x.lng
  //     )
  //     .reduce(
  //       (io, p) => {
  //         io.lngSum += Number(p.lng);
  //         io.latSum += Number(p.lat);
  //         io.sum++;
  //         return io;
  //       },
  //       { lngSum: 0, latSum: 0, sum: 0 }
  //     );
  //     if (!obj.sum) {
  //       console.warn('Точек нет - центра нет');
  //       return;
  //     }
  //     console.log('recalc center');
  //   const newCenter = new Position(obj.latSum / obj.sum, obj.lngSum / obj.sum);
  //   this.center = newCenter;
  // }

  onChangeDate(date: Date) {
    // console.log('date:', date);
    // new Date(moment(date).format('MM.DD.YY HH:mm'));

    this.fromDate = date;
    const h = this.fromDateTo.getHours();
    const m = this.fromDateTo.getMinutes();
    // this.fromDate1 = new Date(date.setDate(date.getDate() - 1));
    // this.fromDateTo = new Date(date.getFullYear(), date.getMonth(), date.getDate(), h, m);
    // this.fromDateTo.setHours(23);
    // this.fromDateTo.setMinutes(59);
  }
  onChangeDateTo(date: Date) {
    this.fromDateTo = date;
  }

  onBuild() {
    this.getItems();
  }
  getSeparator(): string {
    var number = 111.1;
    var numberString = number.toLocaleString();
    let sep = ';';
    if (numberString[3] == '.') sep = ',';
    return sep;
  }
  getTestCoord(): { Longtitude: ''; Lattitude: '' }[] {
    return [
      { Longtitude: '27.9296188', Lattitude: '47.7626388' },
      { Longtitude: '27.8950603', Lattitude: '47.7764886' },
      { Longtitude: '27.8938828', Lattitude: '47.7776381' },
      { Longtitude: '27.8352188', Lattitude: '47.8221559' },
      { Longtitude: '27.8398449', Lattitude: '47.8248735' },
      { Longtitude: '27.8419704', Lattitude: '47.8276912' },
      { Longtitude: '28.7349438', Lattitude: '47.0739512' },
      { Longtitude: '27.8159072', Lattitude: '47.8806402' },
      { Longtitude: '27.8244153', Lattitude: '47.8757329' },
      { Longtitude: '27.8465179', Lattitude: '47.9451809' },
      { Longtitude: '27.8492318', Lattitude: '47.9493674' },
      { Longtitude: '27.8591671', Lattitude: '47.9453839' },
      { Longtitude: '27.8381338', Lattitude: '47.9521204' },
      { Longtitude: '27.8283411', Lattitude: '47.9679717' },
      { Longtitude: '27.8276364', Lattitude: '47.9718369' },
      { Longtitude: '27.8283411', Lattitude: '47.9679717' },
      { Longtitude: '27.8178068', Lattitude: '47.9885578' },
      { Longtitude: '27.8088137', Lattitude: '48.0257471' },
      { Longtitude: '27.7986207', Lattitude: '47.9850712' },
      { Longtitude: '27.7976526', Lattitude: '47.9854399' },
      { Longtitude: '27.8043213', Lattitude: '47.9857188' },
      { Longtitude: '27.8018958', Lattitude: '48.0285665' },
      { Longtitude: '27.8159132', Lattitude: '48.0318298' },
      { Longtitude: '27.8376482', Lattitude: '48.0211596' },
      { Longtitude: '27.8995365', Lattitude: '48.0619798' },
      { Longtitude: '27.9909542', Lattitude: '48.1288506' },
      { Longtitude: '27.9536229', Lattitude: '48.1592138' },
      { Longtitude: '27.955702', Lattitude: '48.1610935' },
      { Longtitude: '27.9552813', Lattitude: '48.1615352' },
      { Longtitude: '27.9535399', Lattitude: '48.1533183' },
      { Longtitude: '27.9187968', Lattitude: '48.1438782' },
      { Longtitude: '28.0223178', Lattitude: '48.087949' },
      { Longtitude: '28.0158059', Lattitude: '48.1160087' },
      { Longtitude: '28.0071822', Lattitude: '48.1269483' },
      { Longtitude: '28.0076287', Lattitude: '48.127614' },
      { Longtitude: '28.0071729', Lattitude: '48.1269623' },
      { Longtitude: '28.0074943', Lattitude: '48.1274112' },
      { Longtitude: '28.0061899', Lattitude: '48.1285511' },
      { Longtitude: '27.9377864', Lattitude: '48.1086038' },
      { Longtitude: '27.9389137', Lattitude: '48.1153616' },
      { Longtitude: '28.8063377', Lattitude: '47.0225896' },
      { Longtitude: '27.9377864', Lattitude: '48.1086038' },
      { Longtitude: '27.9389137', Lattitude: '48.1153616' },
      { Longtitude: '27.8978747', Lattitude: '48.0690876' },
      { Longtitude: '27.8978747', Lattitude: '48.0690876' },
      { Longtitude: '28.0058301', Lattitude: '48.1225664' },
      { Longtitude: '27.9056522', Lattitude: '48.072875' },
      { Longtitude: '27.9068878', Lattitude: '48.0663387' },
      { Longtitude: '27.9055122', Lattitude: '48.065339' },
      { Longtitude: '27.9005976', Lattitude: '48.0643866' },
      { Longtitude: '27.8005274', Lattitude: '48.1146082' },
      { Longtitude: '27.8085183', Lattitude: '48.1116912' },
      { Longtitude: '27.8085183', Lattitude: '48.1116912' },
      { Longtitude: '27.8175366', Lattitude: '48.105634' },
      { Longtitude: '27.8175366', Lattitude: '48.105634' },
      { Longtitude: '27.8175366', Lattitude: '48.105634' },
      { Longtitude: '27.8175366', Lattitude: '48.105634' },
      { Longtitude: '27.7692934', Lattitude: '48.144239' },
      { Longtitude: '27.7692934', Lattitude: '48.144239' },
      { Longtitude: '27.7690584', Lattitude: '48.1470948' },
      { Longtitude: '27.7690584', Lattitude: '48.1470948' },
      { Longtitude: '27.7678603', Lattitude: '48.149791' },
      { Longtitude: '27.7678603', Lattitude: '48.149791' },
      { Longtitude: '27.7671697', Lattitude: '48.1513049' },
      { Longtitude: '27.7671697', Lattitude: '48.1513049' },
      { Longtitude: '27.7907998', Lattitude: '48.1485701' },
      { Longtitude: '27.7907998', Lattitude: '48.1485701' },
      { Longtitude: '27.7907998', Lattitude: '48.1485701' },
      { Longtitude: '27.7907998', Lattitude: '48.1485701' },
      { Longtitude: '27.7927938', Lattitude: '48.1540941' },
      { Longtitude: '27.7927938', Lattitude: '48.1540941' },
      { Longtitude: '27.8237171', Lattitude: '48.0349527' },
      { Longtitude: '27.8237171', Lattitude: '48.0349527' },
      { Longtitude: '27.819768', Lattitude: '48.0334245' },
      { Longtitude: '27.819768', Lattitude: '48.0334245' },
      { Longtitude: '27.8174117', Lattitude: '48.0321233' },
      { Longtitude: '27.8174117', Lattitude: '48.0321233' },
      { Longtitude: '27.8151772', Lattitude: '48.0318506' },
      { Longtitude: '27.8151772', Lattitude: '48.0318506' },
      { Longtitude: '27.8140971', Lattitude: '48.032306' },
      { Longtitude: '27.8140971', Lattitude: '48.032306' },
      { Longtitude: '27.8094846', Lattitude: '48.0326884' },
      { Longtitude: '27.8094846', Lattitude: '48.0326884' },
      { Longtitude: '27.8035952', Lattitude: '48.0355638' },
      { Longtitude: '27.8035952', Lattitude: '48.0355638' },
      { Longtitude: '27.8004283', Lattitude: '48.0328457' },
      { Longtitude: '27.8004283', Lattitude: '48.0328457' },
      { Longtitude: '27.8144739', Lattitude: '48.0165547' },
      { Longtitude: '27.8144739', Lattitude: '48.0165547' },
      { Longtitude: '27.8009349', Lattitude: '48.0340886' },
      { Longtitude: '27.8009349', Lattitude: '48.0340886' },
      { Longtitude: '27.8153653', Lattitude: '48.0254585' },
      { Longtitude: '27.8153653', Lattitude: '48.0254585' },
      { Longtitude: '27.8283411', Lattitude: '47.9679717' },
      { Longtitude: '27.8283411', Lattitude: '47.9679717' },
      { Longtitude: '27.8389279', Lattitude: '47.95726' },
      { Longtitude: '27.8389279', Lattitude: '47.95726' },
      { Longtitude: '27.8495146', Lattitude: '47.9465482' },
      { Longtitude: '27.8495146', Lattitude: '47.9465482' },
      { Longtitude: '27.8329466', Lattitude: '47.9417174' },
      { Longtitude: '27.8329466', Lattitude: '47.9417174' },
      { Longtitude: '27.8194878', Lattitude: '47.8792075' },
      { Longtitude: '27.8194878', Lattitude: '47.8792075' },
      { Longtitude: '27.8130345', Lattitude: '47.8787083' },
      { Longtitude: '27.8130345', Lattitude: '47.8787083' },
      { Longtitude: '27.8295854', Lattitude: '47.8790545' },
      { Longtitude: '27.8295854', Lattitude: '47.8790545' },
      { Longtitude: '27.8303438', Lattitude: '47.8771841' },
      { Longtitude: '27.8303438', Lattitude: '47.8771841' },
      { Longtitude: '27.8295854', Lattitude: '47.8790545' },
      { Longtitude: '27.8295854', Lattitude: '47.8790545' },
      { Longtitude: '27.8779758', Lattitude: '47.7930139' },
      { Longtitude: '27.8779758', Lattitude: '47.7930139' },
      { Longtitude: '27.8872118', Lattitude: '47.7899063' },
      { Longtitude: '27.8872118', Lattitude: '47.7899063' },
      { Longtitude: '27.8908988', Lattitude: '47.7807627' },
      { Longtitude: '27.8908988', Lattitude: '47.7807627' },
      { Longtitude: '27.9011429', Lattitude: '47.7700396' },
      { Longtitude: '27.9011429', Lattitude: '47.7700396' },
      { Longtitude: '27.9030356', Lattitude: '47.767591' },
      { Longtitude: '27.9030356', Lattitude: '47.767591' },
      { Longtitude: '27.9074193', Lattitude: '47.7649928' },
      { Longtitude: '27.9074193', Lattitude: '47.7649928' },
      { Longtitude: '27.9091669', Lattitude: '47.7639954' },
      { Longtitude: '27.9091669', Lattitude: '47.7639954' },
      { Longtitude: '27.9200844', Lattitude: '47.758969' },
      { Longtitude: '27.9200844', Lattitude: '47.758969' },
      { Longtitude: '27.9278342', Lattitude: '47.7626773' },
      { Longtitude: '27.9278342', Lattitude: '47.7626773' },
      { Longtitude: '27.9272736', Lattitude: '47.7661725' },
      { Longtitude: '27.9272736', Lattitude: '47.7661725' },
      { Longtitude: '27.9297098', Lattitude: '47.7628158' },
      { Longtitude: '27.9297098', Lattitude: '47.7628158' },
    ];
  }
  onCreateReport() {
    let result: TrackStatisticItemResponse[] = [];
    this.$api.MapService.GetTrackStatisticEvent.once((response) => {
      if (!response.IsSuccess) {
        this.$notification.error(response.ErrorMessage.toString());
        return;
      }
      var sep = this.getSeparator();

      let result = response.Value;
      var csv = 'User Name' + sep + 'Date' + sep + 'distance(km)\n';
      //user

      result.forEach((row) => {
        csv += row.UserName + '\n';
        //days

        let sum = 0;
        row.RangeStatistics.forEach((item) => {
          let path: Position[] = [];
          csv += sep + moment(item.Date).format('DD.MM.YY') + sep;

          item.Coordinates.forEach((coord) => {
            if (Number(coord.Lattitude) > 0 && Number(coord.Longtitude) > 0) {
              path.push({ lat: Number(coord.Lattitude), lng: Number(coord.Longtitude) });
            }
          });

          let length = this.getDist(path);
          // debugger;
          sum += length;
          // console.log('length', length);
          csv += length.toLocaleString('ru', { useGrouping: false });

          csv += '\n';
        });
        // console.log('sum', sum);
        csv += 'Sum' + sep + sep + sum.toLocaleString('ru', { useGrouping: false });
        csv += '\n';
      });

      var hiddenElement = document.createElement('a');
      hiddenElement.href = 'data:text/csv;charset=utf-8,' + encodeURI(csv);
      hiddenElement.target = '_blank';
      hiddenElement.download = 'people.csv';
      hiddenElement.click();
    });

    this.$notification.success('Отчет успешно создан');
    this.$api.MapService.GetTrackStatistic({
      DateFrom: moment(this.fromDate)
        .utc(true)
        .toDate(),
      DateTo: moment(this.fromDateTo)
        .utc(true)
        .toDate(),
    });
  }
  getDist(path): number {
    var poly = new google.maps.Polyline({
      path: path,
      editable: false,
      strokeColor: '#5FB951',
      strokeOpacity: 1,
      strokeWeight: 4,
    });
    path = poly.getPath();
    let length = google.maps.geometry.spherical.computeLength(path) / 1000;
    return length;
  }
}



// WEBPACK FOOTER //
// ./~/vue-loader/lib/selector.js?type=script&index=0!./scripts/views/pages/page-gps-tracker.vue